export const riderTypes = [
    "ARENA",
    "CLUB",
    "FESTIVAL",
    "SPECIAL_EVENT",
];
export const RiderTypes = {
    ARENA: "ARENA",
    CLUB: "CLUB",
    FESTIVAL: "FESTIVAL",
    SPECIAL_EVENT: "SPECIAL_EVENT",
};
const getFormatedRiderType = (type) => {
    switch (type) {
        case "ARENA":
            return "Arena/Amp/Stadium";
        case "CLUB":
            return "Club/Theatre";
        case "FESTIVAL":
            return "Festival";
        case "SPECIAL_EVENT":
            return "Special Event/Custom";
    }
};
export const riderTypesOptions = riderTypes.map((type) => ({
    label: getFormatedRiderType(type),
    value: type,
}));
export const riderLaborsTypes = [
    "FORKLIFT",
    "OPERATOR",
    "RIGGER",
    "CLIMBER",
];
export const RiderLaborsTypes = {
    FORKLIFT: "FORKLIFT",
    OPERATOR: "OPERATOR",
    RIGGER: "RIGGER",
    CLIMBER: "CLIMBER",
};
export const riderLaborsTypesOptions = riderLaborsTypes.map((type) => ({
    label: type.charAt(0) + type.substring(1).toLowerCase(),
    value: type,
}));
